import {Auth, API} from "aws-amplify";

let apiName = process.env.REACT_APP_APINAME;
let path = "";
let requestBody = "";

class RedmoService {

    async getAreaMangers(callback) {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_PORTAL_FRONTEND+"redmo/getAreaMangers";
        requestBody = {
            body: {},
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async getAgents(mainMerchantId, callback) {

        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_PORTAL_FRONTEND+"redmo/getAgentsByAreaM";
        requestBody = {
            body: {mainMerchantId: mainMerchantId},
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

    async getTransactions(params, callback) {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;

        path = process.env.REACT_APP_URL_PORTAL_FRONTEND+"redmo/getAgentsTransactions";
        requestBody = {
            body: {...params},
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        };

        API.post(apiName, path, requestBody).then(data => {
            return callback(null, data);
        }).catch(error => {
            return callback(error, null);
        });
    }

}

export default RedmoService;